import React, { Component } from "react";
import PropTypes from "prop-types";
import { H4 } from "visual-components/util/texts";

export default class NavTrialCountdown extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const oneDay = 24 * 60 * 60 * 1000;

    const { shouldShow, overrideText, trialEnd } = this.props;

    if (shouldShow || overrideText) {
      const trialEndDate = new Date(trialEnd);
      const now = new Date();
      const isExpired = trialEndDate.getTime() <= now.getTime();
      const daysLeft = Math.max(Math.round((trialEndDate.getTime() - now.getTime()) / oneDay), 0);

      let displayText = overrideText;
      if (shouldShow) {
        if (isExpired) {
          displayText = "Trial Expired";
        } else {
          displayText = `${daysLeft} day${daysLeft > 1 ? "s" : ""} left in trial`;
        }
      }

      return (
        <li
          className="hidden-xs hidden-sm hidden-1065"
          style={{
            letterSpacing: "0",
            position: "relative",
            display: "inline-block",
            padding: "0 16px",
            lineHeight: "6.4rem",
            margin: "0 16px !important",
            opacity: "1 !important",
            verticalAlign: "middle",
            textTransform: "none",
          }}
        >
          <H4 white>
            <i>{displayText}</i>
          </H4>
        </li>
      );
    }
    // don't show anything if they aren't on a trial. duh.
    return null;
  }
}

NavTrialCountdown.propTypes = {
  shouldShow: PropTypes.bool,
  daysLeft: PropTypes.number,
};
